const STORAGE_KEY = 'shopsmt-deals-of-the-day-beta-accepted';

export const DEALS_BETA_DISCLAIMER_TITLE = 'Deal of the Day is in beta';

export const DEALS_BETA_DISCLAIMER_PARAGRAPHS = [
  'Prices can be wrong or out of date — we\'re working hard at identifying the best deals. Always check the retailer\'s website for the current price before you buy.',
];

export const DEALS_BETA_DISCLAIMER_INLINE =
  'Deal of the Day is in beta — prices can be inaccurate or out of date, and listed deals may not always be true bargains. Always check the retailer\'s site for the current price.';

/**
 * @returns {boolean}
 */
export function hasAcceptedDealsBetaDisclaimer() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function acceptDealsBetaDisclaimer() {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* localStorage unavailable */
  }
}
